import { Box, Button, Divider, IconButton, InputBase, LinearProgress, LinearProgressProps, Paper, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import React, { useEffect, useRef, useState } from "react";
import { getPlacementList } from "../../../store/employerActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks/hooks";
import './attendanceContainer.scss'
import SearchIcon from '@mui/icons-material/Search';
import profilePic from "../../../assets/user.jpg"
import excelUpload from "../../../assets/upload.png"
import form from "../../../assets/form.png"
import fileUpload from "../../../assets/fileUpload.png"
import done from "../../../assets/done.png"
// @ts-ignore
import { ExcelRenderer } from 'react-excel-renderer';
import moment from "moment";
import EmployerApi from "../../../store/services/employer";
import { LoadingButton } from "@mui/lab";
import { StudentActions } from "../../../store/StudentAction";
import { Link, useNavigate } from "react-router-dom";
import { createNotifictions } from "../../../utils/helperFunction";

const fetchProfilePics = (length: string) => {
    return fetch(`https://randomuser.me/api/?results=${length}`).then(res => res.json()).then(result => {
        return result
    })
}

const StudentCard = (props: any) => {
    return (
        <Card className="studentCard" onClick={() => {
            props.selected(props.details)
        }}>
            <CardContent className="p-0">
                <div className="flex">
                    <img src={props.image ? props.image : profilePic} alt="profilePicture" className="studentImage"></img>
                    <div className="m-2">
                        <p className="font-weight-700 m-0">{props.details.user.first_name} {props.details.user.last_name}</p>
                        <p className="body-p gray-color subTitle">{props.details.placement.JobRoles}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
const LinearProgressWithLabel = (props: LinearProgressProps & { value: number }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} style={{ borderRadius: "4px" }} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

const AttendanceUpload = (props: any) => {
    const inputFile = useRef<HTMLInputElement | null>(null)
    const [loading, setLoadin] = useState(false)
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [scanComplete, setScanComplete] = useState(false)
    const [progress, setProgress] = React.useState(10);
    const [timer, setTimer] = useState<any>()
    const [attendanceRec, setAttendanceRex] = useState<any>([])
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const acceptedFileType = [".csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
    console.log(props)
    const handleSubmit = async (e: any) => {
        setLoadingBtn(true)
        e.preventDefault()
        let bodyObj = {
            placementId: props.placement.placement.Id,
            attendance: attendanceRec
        }
        EmployerApi.updateAttendanceRecord(bodyObj).then(async res => {
            dispatch(StudentActions.setMessage("Attendance Record Uploaded"))
            createNotifictions({
                target: props.placement.user.Student_ID,
                message: `Attendance record was updated by the employer} `,
                type: "RQ"
            })
            setLoadingBtn(false)
            setScanComplete(false)
        }).catch((e) => {
            if (e.response.status === 403) {
                navigate('/login')
            }
            setLoadingBtn(false)
            dispatch(StudentActions.setMessage("Updation Failed.Try again."))
        }).finally(() => {
            setLoadingBtn(false)
        })
    }


    const handleFileChange = (event: any) => {
        let fileObj = event.target.files[0];
        if (acceptedFileType.includes(fileObj.type)) {
            setLoadin(true)
            ExcelRenderer(fileObj, (err: any, resp: any) => {
                if (err) {
                    console.log(err);
                }
                else {
                    let data = resp.rows.slice(1, 2)[0]
                    let dateRange = []
                    var start = moment(data[2]);
                    var end = moment(data[3]);
                    while (start.isBefore(end)) {
                        dateRange.push(start.format("YYYY-MM-DD").toString())
                        start.add(1, 'd')
                    }
                    let attendanceArr = []
                    for (let date of dateRange) {
                        let attendanceObj = {}
                        if (data[1].split(",").includes(moment(date).format("M/D/YYYY").toString())) {
                            attendanceObj = {
                                day: date,
                                value: 0
                            }
                        }
                        else {
                            attendanceObj = {
                                day: date,
                                value: 1
                            }
                        }
                        attendanceArr.push(attendanceObj)
                    }
                    setAttendanceRex([...attendanceArr])
                }
            });
        }
        else {
            dispatch(StudentActions.setMessage("Invalid File Type Uploaded.Try again."))
        }

    }
    useEffect(() => {
        if (progress === 100) {
            clearTimer()
        }

    }, [progress, timer])
    const clearTimer = () => {
        setLoadin(false)
        setScanComplete(true)
        clearInterval(timer);
        setProgress(10)
    }
    useEffect(() => {
        if (loading) {
            let timer = setInterval(() => {
                setProgress((prevProgress) => (prevProgress + 10));
            }, 800);
            setTimer(timer)
        }
    }, [loading])
    return (
        <div className="align-content-center flex flex-column h-100 justify-content-around p-3">
            <div className="pb-3 w-100">
                <div className="flex justify-content-between mx-3 mb-3">
                    <div>
                        <h4 className="cardTitle">Upload Attendance details</h4>
                        <p className='subTitle gray-color body-p m-0 '>Upload an excel file or fill out the form below.</p>
                    </div>
                    <StudentCard details={props.placement} image={props.image}></StudentCard>
                </div>
                <div className="align-items-center flex flex-column justify-content-center">
                    <div className="align-items-center flex flex-column justify-content-center mx-3 p-3 uploadContainer w-50" onClick={() => {
                        inputFile.current?.click();
                    }}>
                        {
                            scanComplete ? <>
                                <img src={done}></img>
                                <p className='subTitle gray-color body-p m-0 '>Scan Complete.</p>
                                <div className='mt-2'>
                                    <LoadingButton
                                        loading={loadingBtn}
                                        loadingPosition="start"
                                        onClick={handleSubmit}
                                        variant="contained"
                                        className='mx-2'
                                        autoFocus
                                    >
                                        Upload
                                    </LoadingButton>
                                    <Button onClick={() => {
                                        setScanComplete(false)
                                        setLoadin(false)
                                    }}>Cancel</Button>


                                </div>
                            </> :
                                <>
                                    {
                                        loading ? <>
                                            <img src={fileUpload}></img>
                                            <p className='subTitle gray-color body-p m-0 '>Uploading and Scanning File.</p>
                                            <div className="w-100">
                                                <LinearProgressWithLabel value={progress} />
                                            </div>

                                        </> :
                                            <>
                                                <img src={excelUpload}></img>
                                                <p className='subTitle gray-color body-p m-0 '>Click to upload an excel file.</p>
                                                <div className="flex">
                                                    <p className="subTitle gray-color body-p m-0 ">Click to download sample Excel File</p>
                                                    <Link to="/Attendance.xlsx" target="_blank" download>Download</Link>
                                                </div>
                                                <input type='file' id='file' accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileChange} ref={inputFile} style={{ display: 'none' }} />
                                            </>

                                    }

                                </>
                        }
                    </div>
                    <div className="mt-2">
                        <Button variant="contained" onClick={() => {
                            props.cancelEvent()
                        }}>Cancel</Button>
                    </div>
                </div>

            </div>
        </div>
    )
}


const AttendanceContainer = () => {
    const dispatch = useAppDispatch()
    const [searchText, SetSearchText] = useState("")
    const [images, setImages] = useState([])
    const [selected, setSelected] = useState<any>()
    const placementList = useAppSelector((state: any) => state.employer.placements)
    const fetchPlacementList = async () => {
        await dispatch(getPlacementList())
    }
    const searchStudents = (inputText: string) => {
        return placementList.filter((elm: any) => {
            return ("" + elm.user.first_name).includes(inputText) || ("" + elm.user.last_name).includes(inputText)
        })

    }
    useEffect(() => {
        fetchPlacementList()
    }, [])
    useEffect(() => {
        fetchProfilePics(placementList.length).then(res => {
            setImages(res.results.map((elm: any) => {
                return elm.picture.large
            }))
        })
    }, [placementList])
    return (
        <div>
            {
                selected !== undefined && Object.keys(selected).length > 0 ?
                    <>
                        <AttendanceUpload placement={selected} cancelEvent={() => {
                            setSelected({})
                        }} image={images[0]}></AttendanceUpload>
                    </> :
                    <div className="align-content-center flex flex-column h-100 justify-content-around p-3">
                        <div className="flex flex-row justify-content-between pb-3 w-100">
                            <div>
                                <h4 className="cardTitle">Interns</h4>
                                <p className='subTitle gray-color body-p m-0 '>Please select an intern from the below list.</p>

                            </div>

                            <div className="flex justify-content-between">
                                <Paper
                                    component="form"
                                    className="inputBox"
                                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                >
                                    <InputBase
                                        sx={{ ml: 1, flex: 1 }}
                                        placeholder="Search Students"
                                        inputProps={{ 'aria-label': 'search students' }}
                                        value={searchText}
                                        onChange={(e) => {
                                            SetSearchText(e.target.value)
                                        }}
                                    />
                                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                </Paper>
                            </div>
                        </div>
                        <div className='requestContainer'>
                            {
                                placementList.length > 0 && searchStudents(searchText).map((elm: any, index: any) => {
                                    return (
                                        <StudentCard key={index} details={elm} image={images[index]} selected={(elm: any) => {
                                            setSelected(elm)
                                        }}></StudentCard>
                                    )
                                })
                            }
                        </div>
                    </div>
            }

        </div>
    )

}
export default AttendanceContainer;